module.exports = __webpack_public_path__ + "fonts/xeicon.703a9d68.ttf";